module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step4_endcard.a3a0044c.jpg";